import React, { useState } from "react";
import { Row, Col, Form } from "antd";
import { AntdButton, DatePickerField } from "../blueplanitUtils/InputField";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllRecordsAsync } from "../Slices/Thunk/LoginThunk";

const AttendanceEmployeeFilter = ({ setPage, pageSize }) => {
  const dispatch = useDispatch();
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const [form, setForm] = useState({})
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setForm((prev) => ({
      ...prev,
      date: date,
    }));
  };

  const handleSearch = () => {

    dispatch(
      fetchAllRecordsAsync({
        userId: loginUser?.id,
        date: selectedDate ? selectedDate.format('YYYY-MM-DD') : null,
        page: 1,
        pageSize,
      })
    );
  };

  const handleClear = () => {
    setSelectedDate(null);
    setPage(1);
    setForm((prev) => ({
      ...prev,
      date: null,
    }));
    dispatch(fetchAllRecordsAsync({
      userId: loginUser?.id,
      page: 1,
      pageSize,
    }));
  };


  return (
    <>
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]} className="filter-row">
        <Col span={4}>
          <Form.Item labelCol={{ span: 24 }}>
            <DatePickerField
              label="Date"
              value={form.date}
              onChange={handleDateChange}
              format="DD/MM/YYYY"
              allowClear={false}
            />
          </Form.Item>
        </Col>

        <Col span={4} className="col-md-5 d-flex gap-2 justify-content-center" style={{ marginTop: "1.6rem" }}>
          <AntdButton
            variant="outlined"
            size="medium"
            label="Search"
            type="primary"
            onClick={handleSearch}
            style={{ backgroundColor: "#007bff",  color: "white" }}

          />
          <AntdButton
            variant="outlined"
            size="medium"
            label="Clear"
            onClick={handleClear}
            type="primary"
            color="success"
            style={{ backgroundColor: "#837F7F", color: "white" }}
          />
        </Col>
      </Row>
    </>
  );
};

export default AttendanceEmployeeFilter;
